import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginUserComponent } from './components/login-user/login-user.component';
import { TestSheetComponent } from './components/candidate/test-sheet/test-sheet.component';
import { UserHomeComponent } from './components/user/user-home/user-home.component';
import { WelcomeComponent } from './components/user/welcome/welcome.component';
import { CandidateHomeComponent } from './components/candidate/candidate-home/candidate-home.component';
import { Error404Component } from './components/error404/error404.component';
import { LoginCandidateComponent } from './components/login-candidate/login-candidate.component';
import { CandidateCardComponent } from './components/user/candidate-card/candidate-card.component';
import { AuthorizationGuard } from './authorization.guard';
import { CandidatesComponent } from './components/user/candidates/candidates.component';
import { InstructionsComponent } from './components/candidate/instructions/instructions.component';
import { WebcamSnapshotComponent } from './components/candidate/webcam-snapshot/webcam-snapshot.component';
import { TestViewerComponent } from './components/user/test-viewer/test-viewer.component';
import { TestCreatorComponent } from './components/user/test-creator/test-creator.component';
import { RecruiterCardComponent } from './components/user/recruiter-card/recruiter-card.component'

const routes: Routes = [
  { path: 'login', component: LoginUserComponent },
  { path: 'apply', component: LoginCandidateComponent },
  { path: 'instructions', component: InstructionsComponent, canActivate:[AuthorizationGuard] },  
  { path: 'cam', component: WebcamSnapshotComponent, canActivate:[AuthorizationGuard] },  
  {
    path: 'homecandidate', component: CandidateHomeComponent, canActivate:[AuthorizationGuard],
    children: [
      { path: 'test/:testid/:name', component: TestSheetComponent },
    ]
  },
  {
    path: 'homeuser', component: UserHomeComponent, canActivate:[AuthorizationGuard],
    children: [
      { path: 'welcome', component: WelcomeComponent },
      { path: 'candidate/:id', component: CandidateCardComponent },
      { path: 'candidates', component: CandidatesComponent },
      { path: 'test', component: TestViewerComponent },
      { path: 'newtest', component: TestCreatorComponent},
      { path: 'recruiter/:id', component: RecruiterCardComponent },

    ]
  },
  { path: 'error404', component: Error404Component },
  
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '#', redirectTo: '/homeuser', pathMatch: 'prefix' },
  { path: '#', redirectTo: '/homeuser', pathMatch: 'full' }, // redirect to `first-component`
  { path: '**', redirectTo: '/error404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
